<template>
  <div class="clearable-input">
    <input
      type="number"
      class="form-control"
      :id="id"
      :value="value"
      @input="$emit('input', $event.target.value)"
    />

    <clear-icon
      v-if="value"
      @click="$emit('input', null)"
      class="clearable-input-button"
    />
  </div>
</template>

<script>
import clearIcon from "@/assets/icons/horti_07-cross-12px.svg?inline";
export default {
  name: "ClearableInput",
  props: ["value", "id"],
  components: { clearIcon }
};
</script>
